module.exports = require("lodash/isPlainObject");


//////////////////
// WEBPACK FOOTER
// external "lodash/isPlainObject"
// module id = 125
// module chunks = 0 1